import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class MLGAFInfoService {

    static gpaCheckEligibilitySSNNameZip(lastName, zipCode, ssnOrAltId, sessionUUID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'checkEligibilitySSNNameZip',
            [lastName, zipCode, ssnOrAltId, sessionUUID, quoteID],
            additionalHeaders
        );
    }

    static searchGAFIInfoByName(searchText, sessionID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'searchGAFIInfoByName',
            [searchText, sessionID, quoteID],
            additionalHeaders
        );
    }

    static searchGAFIInfoByGpc(gpc, sessionID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'searchGAFIInfoByGpc',
            [gpc, sessionID, quoteID],
            additionalHeaders
        );
    }

    static selectEmployer(dto, sessionID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'selectEmployer',
            [dto, sessionID, quoteID],
            additionalHeaders
        );
    }

    static updateGAFInfo(dto, sessionID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'updateGAFInfo',
            [dto, sessionID, quoteID],
            additionalHeaders
        );
    }

    static checkEligibility(cdfNumber, ssnOrAltId, sessionID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'checkEligibility',
            [cdfNumber, ssnOrAltId, sessionID, quoteID],
            additionalHeaders
        );
    }

    static checkEligibilitySSNNameZip(lastName, zipCode, ssnOrAltId, sessionUUID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'checkEligibilitySSNNameZip',
            [lastName, zipCode, ssnOrAltId, sessionUUID, quoteID],
            additionalHeaders
        );
    }

    static selectEmployee(employeeInfo, sessionUUID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'selectEmployee',
            [employeeInfo, sessionUUID, quoteID],
            additionalHeaders
        );
    }

    static resetEmployee(employeeInfo, sessionUUID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'resetEmployee',
            [employeeInfo, sessionUUID, quoteID],
            additionalHeaders
        );
    }

    static searchFilteredGAFByGPC(gpc, sessionID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'searchFilteredGAFByGPC',
            [gpc, sessionID, quoteID],
            additionalHeaders
        );
    }

    static searchGAFInfoForTypeahead(searchText, sessionID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'searchGAFInfoForTypeahead',
            [searchText, sessionID, quoteID],
            additionalHeaders
        );
    }

    static searchGAFTypeaheadForEndorsement(searchText, jobID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'searchGAFTypeaheadForEndorsement',
            [searchText, jobID],
            additionalHeaders
        );
    }

    static searchFilteredGAFByGPCForEndorsement(gpc, jobNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'searchFilteredGAFByGPCForEndorsement',
            [gpc, jobNumber],
            additionalHeaders
        );
    }

    static selectEmployerForEndorsement(dto, jobNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'selectEmployerForEndorsement',
            [dto, jobNumber],
            additionalHeaders
        );
    }

    static searchGAFInfosForEndorsement(searchText, jobNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'searchGAFInfoByNameAndJobNumber',
            [searchText, jobNumber],
            additionalHeaders
        );
    }

    static updateGAFInfoForEndorsement(dto, jobNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'updateGAFInfoForEndorsement',
            [dto, jobNumber],
            additionalHeaders
        );
    }

    static checkEligibilityForEndorsement(cdfNumber, ssnOrAltId, jobNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'checkEligibilityForEndorsement',
            [cdfNumber, ssnOrAltId, jobNumber],
            additionalHeaders
        );
    }

    static verifyEmployee(lastName, zipCode, ssnOrAltId, isSSN, sessionUUID, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gaf'),
            'verifyEmployee',
            [lastName, zipCode, ssnOrAltId, isSSN, sessionUUID, quoteID],
            additionalHeaders
        );
    }    
}
